<template>
  <div class="overflow-auto">
    <div class="d-flex flex-column justify-content-between h-100">
      <div>
        <img alt="Logo" src="@/assets/images/CI/Viacor_Claim_pos_silver_RGB.png" class="mx-4" style="width: 250px;" />
        <el-divider />
        <MenuEntries />
      </div>
      <div>
        <BottomLinkBar @logout="onLogout" @account="onAccount" />
      </div>
    </div>
    <Sidebar ref="sidebar" @toggled="onToggled">
      <div class="d-flex flex-column justify-content-between h-100">
        <div>
          <img alt="Logo" src="@/assets/images/CI/Viacor_Claim_pos_silver_RGB.png" class="mx-4" style="width: 250px" />
          <el-divider />
          <MenuEntries />
        </div>
        <div>
          <BottomLinkBar @logout="onLogout" @account="onAccount" />
        </div>
      </div>
    </Sidebar>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import MenuEntries from './MenuEntries';
import BottomLinkBar from './BottomLinkBar';
import { EventBus } from '../../event-bus.js';
import Sidebar from './sidebar/Sidebar';
import StoreModules from '../../store/store-modules';
import PlatformMixin from '../../mixins/PlatformMixin';

export default {
  name: 'MainNavigationSidebar',
  components: { Sidebar, BottomLinkBar, MenuEntries },
  mixins: [PlatformMixin],
  props: {},
  mounted() {
    EventBus.$on('sidebarToggle', this.sidebarToggle);
  },
  destroyed() {
    EventBus.$off('sidebarToggle');
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    ...mapActions(StoreModules.USER, ['logout']),
    async onLogout() {
      await this.logout();
      this.$router.replace({ name: this.$routeNames.LOGIN_PAGE_ROUTE });
      window.location.reload();
    },
    onAccount() {
      this.$refs.sidebar.closeSidebarPanel();
      this.$router.push({ name: this.$routeNames.MY_ACCOUNT_PAGE_ROUTE });
    },
    sidebarToggle() {
      this.$refs.sidebar.toggle();
    },
    onToggled(state) {
      EventBus.$emit('resetBurger', state);
    },
  },
};
</script>

<style scoped></style>
